import odata from '@/core/api/mixin/odata'
export default {
  ...odata('rules'),
}
